import React from 'react';
import { CustomArrowProps } from 'react-slick';

interface Props extends CustomArrowProps {
  isPrevious?: boolean;
}

const CarouselArrow: React.FC<Props> = props => {
  const { className, style, onClick, isPrevious } = props;
  return (
    <button
      type="button"
      className={className}
      style={{ ...style, opacity: 0 }}
      onClick={onClick}
      aria-label={`${isPrevious ? 'previous' : 'next'} slide`}
    />
  );
};

CarouselArrow.defaultProps = {
  isPrevious: false,
};

export default CarouselArrow;
